import React from 'react';

import PropTypes from 'prop-types';

import { TableCell, TableRow } from '@/components/ui/table';

const EmptyContent = ({ columns }) => (
  <TableRow>
    <TableCell className="h-24 text-center" colSpan={columns.length}>
      No results.
    </TableCell>
  </TableRow>
);

EmptyContent.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default EmptyContent;
